/**
 * Role Constants
 * Centralized role values and permissions used throughout the application
 */
// User Roles (database enum format)
export const USER_ROLE = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    EDITOR: 'EDITOR',
    VIEWER: 'VIEWER',
};
// User Roles (lowercase variants for frontend)
export const USER_ROLE_LOWERCASE = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    EDITOR: 'editor',
    VIEWER: 'viewer',
};
// Team Member Type
export const TEAM_MEMBER_TYPE = {
    EMPLOYEE: 'EMPLOYEE',
    FREELANCER: 'FREELANCER',
    CONTRACTOR: 'CONTRACTOR',
};
// Service Type
export const SERVICE_TYPE = {
    STRATEGY: 'STRATEGY',
    DESIGN: 'DESIGN',
    DEVELOPMENT: 'DEVELOPMENT',
    MARKETING: 'MARKETING',
    CONSULTING: 'CONSULTING',
};
// Role hierarchy levels (higher number = more permissions)
export const ROLE_HIERARCHY = {
    [USER_ROLE.VIEWER]: 1,
    [USER_ROLE.EDITOR]: 2,
    [USER_ROLE.ADMIN]: 3,
    [USER_ROLE.SUPER_ADMIN]: 4,
};
// Role display names
export const ROLE_DISPLAY_NAMES = {
    [USER_ROLE.SUPER_ADMIN]: 'Super Admin',
    [USER_ROLE.ADMIN]: 'Admin',
    [USER_ROLE.EDITOR]: 'Editor',
    [USER_ROLE.VIEWER]: 'Viewer',
};
// Role descriptions (uppercase keys)
export const ROLE_DESCRIPTIONS = {
    [USER_ROLE.SUPER_ADMIN]: 'Complete system control with all permissions',
    [USER_ROLE.ADMIN]: 'Full access to all features',
    [USER_ROLE.EDITOR]: 'Can create and edit content',
    [USER_ROLE.VIEWER]: 'Read-only access',
};
// Role descriptions (lowercase keys for frontend)
export const ROLE_DESCRIPTIONS_LOWERCASE = {
    [USER_ROLE_LOWERCASE.SUPER_ADMIN]: 'Complete system control with all permissions',
    [USER_ROLE_LOWERCASE.ADMIN]: 'Full access to all features',
    [USER_ROLE_LOWERCASE.EDITOR]: 'Can create and edit content',
    [USER_ROLE_LOWERCASE.VIEWER]: 'Read-only access',
};
// Helper function to check if a role has sufficient permissions
export const hasMinimumRole = (userRole, requiredRole) => {
    return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
};
